import Axios, {
  AxiosRequestHeaders,
  AxiosResponse, AxiosResponseHeaders
} from 'axios';

import { SSOEnum } from '@interface/public';
import {
  RequestSSORefresh, ResponseSSORefresh, AxiosSSORefresh
} from '@server/apiSSO';
import {
  RequestStoreGetPermission, ResponseStoreGetPermission, AxiosStoreGetPermission
} from '@server/apiStore';
import FN from "@constant/function";

export default class RQ {
  public static readonly SSO = { // SSO
    /**
     * 检测
     * @return {boolean} 返回是否已登录
     */
    check(): boolean {
      return $Store.User().token !== '' &&
        $Store.User().userID !== '' &&
        $Store.User().username !== '';
    },
    
    /**
     * 登录
     * @param {string} href 登录后的回调地址
     * @param {string} operate 操作
     * @param {boolean} isOpen 是否打开新标签页
     */
    login(href: string = location.href, operate: string = '', isOpen: boolean = false): void {
      let data: any = {
          [$Enum.ParamEnum.Source]: encodeURIComponent(href),
          [$Enum.ParamEnum.Operate]: operate
        },
        newHref = '';
      
      $Store.User().sourceAccess && (data[$Enum.ParamEnum.SourceAccess] = $Store.User().sourceAccess);
      newHref = $FN.Url.set(data, `${ $Config.Href.sso }/sso/${ $Enum.SSOEnum.Index }`);
      
      isOpen
        ? open(newHref)
        : (location.href = newHref);
    },
    
    /**
     * 退出登录
     */
    logout(): void {
      $Store.User().clearInfo();
    },
    
    /**
     * 权限
     */
    async permission(): Promise<any> {
      if (!$RQ.SSO.check()) return;
      
      await AxiosStoreGetPermission({} as RequestStoreGetPermission)
        .then((response: any) => {
          const data: ResponseStoreGetPermission = response.data;
          
          if (data.code !== $Enum.CodeEnum.Normal) return;
          
          $Store.User().store = data.data;
        });
    }
  };
  
  /**
   * 请求静态文件
   * @param {string} url
   */
  public static GetFile(url: string): Promise<any> {
    return Axios.get(url, {
      timeout: 10000,
      transformRequest: [
        (data: any, header: AxiosRequestHeaders): string => {
          // console.log('/////请求文件', url);
          return data;
        }
      ],
      transformResponse: [
        (data: string, header: AxiosResponseHeaders): string => {
          // console.log('/////接收文件', data);
          return data;
        }
      ]
    });
  }
  
  /**
   * 请求刷新会话
   * @param {Function} callback 回调
   */
  public static RefreshToken(callback: Function = null): void {
    AxiosSSORefresh({} as RequestSSORefresh)
      .then((response: any) => {
        const data: ResponseSSORefresh = response.data;
        
        if (data.code !== $Enum.CodeEnum.Normal) return;
        
        $Store.User().updateInfo({
          token: data.data.token
        });
        
        callback && callback();
      });
  }
  
  /**
   * 飞书WebHook
   * @param {string} username 用户名称
   * @param {string} content 事件
   */
  public static async PushWebHook(username: string, content: string): Promise<any> {
    const url = 'https://open.feishu.cn/open-apis/bot/v2/hook/be1d3001-3e6d-461f-8105-afb22a146e9b',
      newData = {
        msg_type: 'post',
        content: {
          post: {
            zh_cn: {
              title: '官网消息通知',
              content: [
                [
                  {
                    tag: 'text',
                    text: `用户名：${ username }`
                  }
                ],
                [
                  {
                    tag: 'text',
                    text: `触发操作：${ content }`
                  }
                ],
                [
                  {
                    tag: 'text',
                    text: `页面地址：${ String($Application.Router.currentRoute.value.name) }`
                  }
                ]
              ]
            }
          }
        }
      };
    
    await Axios.post(url, newData)
      .then((response: AxiosResponse) => {
        response.status !== 200 && console.log('WebHook：消息发送失败');
      })
      .catch((e: any) => {
        console.log('WebHook：消息发送失败');
      });
  }
  
  /**
   * 前往GSS
   */
  public static async GoGSS(): Promise<any> {
    if ($RQ.SSO.check()) {
      await $RQ.PushWebHook($Store.User().username, $Enum.TextEnum.OperateGSS);
      open($Config.Href.gss);
    } else {
      $RQ.SSO.login($Config.Href.gss, '', true);
    }
  }
}